import { defineComponent as _defineComponent } from 'vue'
import { formatarTelefone } from '@/shareds/formatadores'
import { authModule } from '@/store'
import Irmao from 'common/types/Irmao'


export default /*#__PURE__*/_defineComponent({
  __name: 'ContatoDoIrmao',
  props: {
    irmao: null
  },
  setup(__props: any) {



return { __sfc: true,formatarTelefone, authModule }
}

})